<template>
  <div>
    <div class="box" v-for="(history, index) in service_history">
      <article class="media">
        <div class="media-content">
          <div class="content">
            <p>
              <strong>{{ history.title }}</strong>
              <br>
              <br>
              <pre v-html="history.history"></pre>
              <article class="media" v-if="history.files.length > 0">
                <template v-if="history.showFiles == false">
                  <a class="button" @click="loadFiles(history, index)"><span class="icon"><i class="fa fa-paperclip" aria-hidden="true"></i></span><span>Show attachments ({{history.files.length}})</span></a>
                </template>
                <template v-else>
                    <div class="columns is-multiline">
                      <div class="column is-12"><span style="font-weight: bold;"><i class="fa fa-paperclip" aria-hidden="true"></i> Attachments</span></div>
                      <template v-for="file in history.history_files">
                        <div class="column is-12" style="text-align: center;">
                          <template v-if="file['ext'].toLowerCase() == 'jpg' || file['ext'].toLowerCase() == 'gif' || file['ext'].toLowerCase() == 'png' || file['ext'].toLowerCase() == 'jpeg'">
                            <a :href="file['url']" target="_blank" style="border-bottom: none;">
                              <img :src="file['url']" alt="" width="90%">
                            </a>
                          </template>
                          <template v-else>
                              <a :href="file['url']" target="_blank" style="border-bottom: none;">
                                <i class="fa fa-file-o fa-4" aria-hidden="true"></i>
                                {{file['name']}}
                              </a>
                          </template>
                        </div>
                        <div class="column is-12">
                          <article class="media">
                          </article>
                        </div>
                      </template>
                    </div>
                </template>
              </article>
              <small>{{ history.user.name }}</small>
              <small style="float: right;">Created: {{ history.created_at }}</small>
            </p>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        service_history: null
      }
    },
    props: {
      service: {
        type: Object
      },
      reload: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      reload () {
        if (this.reload) {
          this.loadData()
          window.location.reload()
        }
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.loadData()
      })
    },
    methods: {
      loadData () {
        this.$http.get(this.$store.state.config.apiURL + '/services/' + this.service.id + '/history').then((response) => {
          this.service_history = response.body
        }, (response) => {

        })
      },
      loadFiles (history, index) {
        this.$http.get(this.$store.state.config.apiURL + '/services/history/files', {params: {'service_id': history.service_id, 'history_id': history.id}}).then((response) => {
          this.service_history[index].history_files = response.body
          this.service_history[index].showFiles = true
        }, (response) => {
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  pre {
    background-color: #FFFFFF;
    white-space: -moz-pre-wrap; /* Mozilla, supported since 1999 */
    white-space: -pre-wrap; /* Opera */
    white-space: -o-pre-wrap; /* Opera */
    white-space: pre-wrap; /* CSS3 - Text module (Candidate Recommendation) http://www.w3.org/TR/css3-text/#white-space */
    word-wrap: break-word; /* IE 5.5+ */
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Helvetica, Arial, sans-serif;
    color: #4a4a4a;
    font-size: 1rem;
    font-weight: 400;
  }
</style>



// WEBPACK FOOTER //
// History.vue?5a2f6e27